// import { defaultRootConfigNode, processMainOfferDiscountConfig, calcComboDiscount } from './config'
// // import router from '/src/router'
// import DeviceDetector from '@/plugins/device-detector'
// import moment from 'moment'
import { sum, map, filter } from 'lodash'

export default {
  cart: state => state.cart,
  cartLines: (state, getters, rootState, rootGetters) => {
    return filter(getters.cart.lines, (line) => {
      return rootGetters['menu/dishById'](line.id)
    })
  },
  cartLinesWithData: (state, getters, rootState, rootGetters) => {
    return map(getters.cartLines, (line) => {
      let dishData = rootGetters['menu/dishById'](line.id)
      return { ...line, ...{ dish: dishData } }
    })
  },
  totalSum: (state, getters, rootState, rootGetters) => {
    return sum(map(getters.cartLines, (line) => {
      let dish = rootGetters['menu/dishById'](line.id)
      return (+dish.price - +dish.discount) * line.quantity
    }))
  },
  totalSumBeforeDiscount: (state, getters, rootState, rootGetters) => {
    return sum(map(getters.cartLines, (line) => {
      let dish = rootGetters['menu/dishById'](line.id)
      return +dish.price * line.quantity
    }))
  },
  totalItems: (state, getters) => {
    return sum(map(getters.cart.lines, (line) => {
      return line.quantity
    }))
  },
  availableGiftsByPromotions: (state, getters, rootState, rootGetters) => {
    let giftPromotions = filter(rootGetters['content/promotions'], promotion => promotion.acf.type === 'gifts')

    return map(giftPromotions, (promotion) => {
      // let availableRows = filter(promotion.acf.conditions, condition => parseInt(condition.min_sum) <= getters.totalSum)
      // let unavailableRows = filter(promotion.acf.conditions, condition => parseInt(condition.min_sum) > getters.totalSum)

      // let messageBullets = map(unavailableRows, row => 'При заказе от ' + row.min_sum + ' ₽ Вы можете выбрать «' + rootGetters['menu/dishById'](row.dish_id).post_title + '» в подарок')
      //
      // let mainMessage = ''
      // if (availableRows.length === 0) {
      //   mainMessage = 'Обратите внимание!'
      // } else if (unavailableRows.length !== 0) {
      //   mainMessage = 'Обратите внимание!'
      // } else {
      //   mainMessage = 'За заказ на сумму от ' + availableRows[availableRows.length - 1].min_sum + ' ₽ Вы можете выбрать любой подарок'
      // }

      return {
        id: promotion.id,
        dishes: map(promotion.acf.conditions, (condition) => {
          return { ...rootGetters['menu/dishById'](condition.dish_id), ...{ needSum: parseInt(condition.min_sum) > getters.totalSum ? parseInt(condition.min_sum) : null } }
        })
        // mainMessage: mainMessage,
        // messageBullets: messageBullets
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/cart/getters.js